const trimStartAndStripStr = (str) => str.trimStart().replace(/ +/g, " ") 

export default trimStartAndStripStr